// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Fbq from './fbq/fbq';
import Log from './plugin/vue-log'
import Home from './pages/Home';
import router from './router';
import store from './store/vuex_store';
import VueEvent from './plugin/vue-event';
import VueSession from 'vue-session';
import googFb from './google/google';
import Kf from './kf/kf';
import VueLazyload from 'vue-lazyload';
import {
    getQueryVariable
} from '@/utils/index';
Vue.use(VueSession)
import {
    px2rem
} from './utils/index'
// console.log("process.env")
Vue.config.productionTip = false;

Vue.use(Log)
Vue.use(VueEvent)
Vue.prototype.$Fbq = Fbq
    // Fbq.getFbqId()

import Mint from 'mint-ui';
import 'mint-ui/lib/style.css';

import Vant from 'vant';

import 'vant/lib/index.css';
import '@/assets/font/font.css';

Vue.use(Vant);

Vue.use(Mint);
Vue.use(VueLazyload, {
    error: 'dist/error.png',

    loading: 'dist/loading.gif'

});
import {
    Locale
} from 'vant';
import zhTW from 'vant/lib/locale/lang/zh-TW';

Locale.use('zh-TW', zhTW);

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
// window.localStorage.setItem('language','tw')
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import zh from '@/i18n/zh' // 简体中文语言包
import tw from '@/i18n/tw' // 繁体中文语言包
import ma from '@/i18n/ma' // 马来语言包
import en from '@/i18n/en' // 英文语言包
import ja from '@/i18n/ja' // 日文语言包
import tg from '@/i18n/tg' // 泰语
import hk from '@/i18n/hk' // 香港语
import yn from '@/i18n/yn' // 越南
import flb from '@/i18n/flb' // 菲律宾
import is from '@/i18n/is' // 印尼
import 'c-swipe/dist/swipe.css';
import { Swipe, SwipeItem } from 'c-swipe';
const i18n = new VueI18n({
    locale:sessionStorage.getItem('locale')||'tw',
    // locale: window.localStorage.getItem('language') === null ? 'tw' : window.localStorage.getItem('language'), // 语言标识，设置默认语言
    messages: {
        'zh': zh, // 简体中文
        'tw': tw,// 繁体中文
        'ma': ma,// 马来西亚
        'en': en,// 英文
        'ja': ja,// 日文
        'tg': tg,// 泰语
        'hk': hk,// 香港语
        'yn': yn,// 越南
        'flb': flb,// 菲律宾
        'is': is,//印尼
    }
})
Vue.component('swipe', Swipe);
Vue.component('swipe-item', SwipeItem);
Vue.prototype.$px2rem = px2rem;
const vue = new Vue({
    el: '#app',
    router,
    i18n,
    store,
    components: {
        Home
    },
    template: '<home/>',
});
initAppData(vue)

if (window.location.href.indexOf('storeid') != -1) {
    vue.$session.set('elenve', window.location.href);
}
// console.log("=====ele=", vue.$session.get('elenve'))

function initAppData(vue) {
    vue.$store.commit('goods/initShopCartGoods')
}


// WEBPACK FOOTER //
// ./src/main.js